import { render, staticRenderFns } from "./IndexView.vue?vue&type=template&id=0bc2f76d&"
import script from "./IndexView.vue?vue&type=script&lang=js&"
export * from "./IndexView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports